import {
  isString,

} from './internal';
import { createOptionalGuard } from './isOptional';

export default createOptionalGuard<string>(isString);
